import { Badge } from '@/components/ui/badge';
import type { ConsiderationCriticality } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const ConsiderationCriticalityBadge: FC<{ criticality: ConsiderationCriticality | undefined }> = ({
    criticality,
}) => {
    if (!criticality) {
        return <span className="text-muted-foreground">-</span>;
    }

    switch (criticality) {
        case 'optional':
            return <Badge className="bg-gray-100 text-gray-400 hover:bg-gray-100">optional</Badge>;
        case 'recommended':
            return <Badge className="bg-green-50 text-green-600 hover:bg-green-50">recommended</Badge>;
        case 'necessary':
            return <Badge className="bg-blue-50 text-blue-600 hover:bg-blue-50">necessary</Badge>;
        case 'urgent':
            return <Badge className="bg-yellow-50 text-yellow-600 hover:bg-yellow-50">urgent</Badge>;
        case 'critical':
            return <Badge className="bg-red-50 text-red-600 hover:bg-red-50">critical</Badge>;
        default:
            assertUnreachable(criticality);
    }
};
